import React, { Component } from "react";

import BrowserCheckAlert from "../browser/BrowserCheckAlert";
import AccountCard from "../components/UserAccountCard";
import InvitationDetails from "./invitationdetails";

interface IProps {
  invitation: server.dto.Invitation
}

export default class ConfirmUserPanel extends Component<IProps> {
  public render(): JSX.Element {
    const acceptInvitationUrl = this.props.invitation.paths.acceptAbsolute;

    const signOutUrl = window.CoreApi.Authentication.Signout.absoluteUrl(encodeURIComponent(this.props.invitation.paths.landingAbsolute));

    return (
      <div className="s1_main-panel small">
        <div className="s1_main-panel-content">
          <BrowserCheckAlert browser={site.browser} />

          <InvitationDetails invitation={this.props.invitation} />

          <div style={{ alignSelf: "center", width: "fit-content" }}>
            <fieldset>
              <legend>{RESX.Account.UseThisAccount}</legend>

              <AccountCard
                user={site.currentUser}
                className="margin-bottom-big" />

              <div className="margin-bottom">
                <a
                  href={acceptInvitationUrl}
                  className="button-new primary fluid">
                  {RESX.AdvancingInvitation.YesUseThisAccount}
                </a>
              </div>

              <div>
                <a
                  href={signOutUrl}
                  className="button-new secondary fluid">
                  {RESX.AdvancingInvitation.NoUseDifferentAccount}
                </a>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    );
  }
}
